import * as React from "react";
//#region types
import { TranslationKeys } from "translations";
import { LoadingProps } from "models/propTypes/loginPropTypes";
//#endregion
//#region components
import { Grid, CircularProgress } from "@mui/material";
import StyledButton from "../buttons/styledButton";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const Loading: React.FC<LoadingProps> = (props) => {
  return (
    <Grid container>
      <Grid item container justifyContent="center">
        <CircularProgress size={144} thickness={4} className={cssExports.loadingProgress} />
      </Grid>
      <Grid item container justifyContent="center" className={cssExports.loadingText}>
        {props.customText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.BankIdProcessing)}
      </Grid>

      {props.cancelLoadingText && (
        <Grid item container>
          <StyledButton onClick={props.onLoadingCancelHandler} secondary className={cssExports.loginButton}>
            {LocalizationHelperInstance.getFormattedMessage(props.cancelLoadingText)}
          </StyledButton>
        </Grid>
      )}
    </Grid>
  );
};

export default Loading;
